import initialState from './initialState'
import {FETCH_POLITICAL_AFFILIATIONS, RECEIVE_POLITICAL_AFFILIATIONS} from '../actions/actionTypes'

export default function politicalAffiliations(state = initialState.politicalAffiliations, action) {
	let newState
	switch (action.type) {
	case FETCH_POLITICAL_AFFILIATIONS:
		return {
			...action,
			isFetching: true
		}
	case RECEIVE_POLITICAL_AFFILIATIONS:
		newState = action.politicalAffiliations
		return {
			...newState,
			isFetching: false
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/politicalAffiliations.js